/** Workflow bands (§7.5). Rank order MUST match `sales_call_bands.BAND_RANK` —
 *  the server sorts by it and the sections render in that order. */
export const BAND_ORDER = [
  'follow_up_due',
  'health_slipping',
  'due_now',
  'coming_up',
  'never_contacted',
  'cadence_slipped',
  'dormant',
  'in_rhythm',
  'resting',
] as const;

export const BAND_LABEL: Record<string, string> = {
  follow_up_due: 'Follow-up due',
  health_slipping: 'Health slipping',
  due_now: 'Due now',
  coming_up: 'Coming up',
  never_contacted: 'Never contacted',
  cadence_slipped: 'Cadence slipped',
  dormant: 'Dormant',
  in_rhythm: 'In rhythm',
  resting: 'Worked recently',
};

export const BAND_TIP: Record<string, string> = {
  follow_up_due: 'You picked a date and it has arrived. A promise you made outranks anything computed.',
  health_slipping: 'URGENT or HIGH tier. Worth a call whatever their contact cadence says.',
  due_now: 'At their own usual contact interval — call before they slip.',
  coming_up: 'Approaching their usual interval. Get ahead of it.',
  never_contacted: 'No CSE contact on record. Unknown rather than overdue — 6% of the book.',
  cadence_slipped: 'Well past their own interval. Over half the book sits here; work it after the bands above.',
  dormant: 'More than 4x their interval. A win-back conversation, not a scheduling one.',
  in_rhythm: 'Contacted within their normal rhythm. Nothing to do — listed so you can still find them.',
  resting: 'You already set a status. It comes back when that status expires.',
};

/** Bands that open expanded. Mirrors `DEFAULT_OPEN_BANDS` on the server.
 *  The rest are still present and still counted — a rep must be able to reach any
 *  client, including the ones with nothing to do. */
export const DEFAULT_OPEN_BANDS = new Set<string>([
  'follow_up_due',
  'health_slipping',
  'due_now',
  'coming_up',
]);
